export default "__VITE_ASSET__DqSj6Q$2__"